import HOC from '../HOC';
import {talk_sport} from '../utility';

let Football = () => {return null;}

export default HOC(Football, talk_sport);



// WEBPACK FOOTER //
// ./src/components/News/Football.js